module.exports = __webpack_public_path__ + "img/engranes.849e2a5c.png";